import { useEffect } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { updateProjectById } from "../../api/projects";
import { useAllPartnersHooks } from "../../utils/project/PartnerUtils";
import { useProjectHooks } from "../../utils/ProjectsUtilHooks";
import useRegionHooks from "../../utils/RegionHooks";
import AlertBox from "../AlertBox";
import { RequiredAsterisk } from "../FormHelper";
import { LoadingInsideBox, LoadingInsideBoxWrapper } from "../Loading";
import FramedPoolForm from "./FramedPoolForm";
import OltForm from "./OltForm";
import Toggle from "react-toggle";

export default function ModalProjectUpdate({ show, id, onClose, onSuccess }) {
  let project = useProjectHooks({ id });
  let { partners } = useAllPartnersHooks();

  let [alert, setAlert] = useState({ show: false, message: "", type: "" });
  let [form, setForm] = useState({
    name: "",
    pic_name: "",
    slug: "",
    partner_id: "",
    framed_pool: null,
    new_framed_pool: "",
    olt: null,
    vlan: "",
    vlan_profile: "",
    olts: [],

    user_activation: 0,
    commission_disbursement: 0,
    invoice_value_added_tax: 0,
    invoice_value_added_tax_rate: 0,
    commissions: [
      { type: "technician", installation: 0, relocate: 0, dismantle: 0 },
      { type: "technician-freelance", installation: 0, relocate: 0, dismantle: 0 },
      { type: "helper", installation: 0, relocate: 0, dismantle: 0 },
      { type: "helper-freelance", installation: 0, relocate: 0, dismantle: 0 },
      { type: "sales", installation: 0 },
      { type: "sales-freelance", installation: 0 },
    ],
  });

  let [loading, setLoading] = useState(null);

  let address = useRegionHooks({ reset: false });

  useEffect(() => {
    if (project.fetched) {
      let formData = {
        name: project.data.name,
        pic_name: project.data.pic_name,
        slug: project.data.slug,
        partner_id: project.data.partner_id || "",
        framed_pool: project.data.framed_pool
          ? { value: project.data.framed_pool, label: project.data.framed_pool }
          : null,
        olt: project.data.olt_id
          ? { value: project.data.olt_id, label: project.data.olt.name }
          : null,
        vlan: project.data.vlan || "",
        vlan_profile: project.data.vlan_profile || "",
        user_activation: project.data.user_activation || 0,
        commission_disbursement: project.data.commission_disbursement || 0,
        invoice_value_added_tax: project.data.invoice_value_added_tax || 0,
        invoice_value_added_tax_rate: project.data.invoice_value_added_tax_rate || 0,
        olts: [],
      };

      formData.commissions = [
        { type: "technician", installation: 0, relocate: 0, dismantle: 0 },
        { type: "technician-freelance", installation: 0, relocate: 0, dismantle: 0 },
        { type: "helper", installation: 0, relocate: 0, dismantle: 0 },
        { type: "helper-freelance", installation: 0, relocate: 0, dismantle: 0 },
        { type: "sales", installation: 0 },
        { type: "sales-freelance", installation: 0 },
      ];

      // Check secondary olt
      if (project.data.olts?.length) {
        project.data.olts.forEach((olt) => {
          formData.olts.push({
            olt: olt.id ? { value: olt.id, label: olt.name } : null,
            olt_vlan: olt.vlan,
            olt_vlan_profile: olt.vlan_profile,
            olt_framed_pool: olt.framed_pool
              ? { value: olt.framed_pool, label: olt.framed_pool }
              : null,
          });
        });
      }

      // Check if project.data.commissions exists and is not empty
      // code generated using AI O(n^2) double loop
      if (project.data.commissions && project.data.commissions.length > 0) {
        project.data.commissions.forEach((commission) => {
          const existingIndex = formData.commissions.findIndex(
            (item) => item.type === commission.type
          );

          if (existingIndex !== -1) {
            formData.commissions[existingIndex] = { ...commission };
          } else {
            formData.commissions.push({ ...commission });
          }
        });
      }

      setForm({ ...formData });

      address.setAddress(project.data.address);
      address.setRt(project.data.rt);
      address.setRw(project.data.rw);
      address.setProvince(project.data.addresses.province);
      address.setCity(project.data.addresses.kota_kab);
      address.setDistrict(project.data.addresses.kecamatan);
      address.setAddressId(String(project.data.address_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.data, project.fetched]);

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setAlert({ show: false, message: "", type: "" });
    setForm({
      name: "",
      pic_name: "",
      slug: "",
      partner_id: "",
      framed_pool: null,
      new_framed_pool: "",
      olt: null,
      vlan: "",
      vlan_profile: "",
      user_activation: 0,
      commission_disbursement: 0,
      invoice_value_added_tax: 0,
      invoice_value_added_tax_rate: 0,

      olts: [],

      secondary_olt: null,
      secondary_olt_vlan: "",
      secondary_olt_vlan_profile: "",
      secondary_olt_framed_pool: null,

      commissions: [
        { type: "technician", installation: 0, relocate: 0, dismantle: 0 },
        { type: "technician-freelance", installation: 0, relocate: 0, dismantle: 0 },
        { type: "helper", installation: 0, relocate: 0, dismantle: 0 },
        { type: "helper-freelance", installation: 0, relocate: 0, dismantle: 0 },
        { type: "sales", installation: 0 },
        { type: "sales-freelance", installation: 0 },
      ],
    });
    address.resetRegion();
  };

  const onChangeCommission = (index, key, value) => {
    let tempForm = { ...form };
    tempForm.commissions[index][key] = value;
    setForm({ ...tempForm });
  };

  const sendDataProject = async (formData) => {
    setLoading(true);
    try {
      let response = await updateProjectById(id, formData);
      onSuccess(true, response.data.message);
      handleClose();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message, type: "danger" });
    }
    setLoading(false);
  };

  const onSubmitData = (event) => {
    event.preventDefault();
    let formData = {
      ...form,
      address: address.address,
      rt: address.rt,
      rw: address.rw,
      address_id: address.addressId,
      olts: [],
    };

    if (formData.framed_pool?.value) {
      if (formData.framed_pool?.value === "add-new") {
        formData.framed_pool = "";
      } else {
        formData.framed_pool = formData.framed_pool.value;
        formData.new_framed_pool = "";
      }
    } else {
      formData.framed_pool = "";
    }

    formData.olt_id = form.olt?.value || "";
    delete formData.olt;

    form.olts.forEach((olt) => {
      if (olt.olt) {
        formData.olts.push({
          id: olt.olt.value,
          framed_pool: olt.olt_framed_pool.value,
          vlan: olt.olt_vlan,
          vlan_profile: olt.olt_vlan_profile,
        });
      }
    });
    sendDataProject(formData);
  };

  const onAddOlt = () => {
    let temp_form = { ...form };

    temp_form.olts.push({
      olt: null,
      olt_vlan: "",
      olt_vlan_profile: "",
      olt_framed_pool: null,
    });

    setForm(temp_form);
  };

  // Remove OLT from the list
  const onRemoveOlt = (index) => {
    let temp_form = { ...form };
    temp_form.olts.splice(index, 1);
    setForm(temp_form);
  };

  // Change OLT value at specific index
  const onChangeOltVal = (index, field, value) => {
    let temp_form = { ...form };
    if (!temp_form.olts[index]) {
      temp_form.olts[index] = {
        olt: null,
        olt_vlan: "",
        olt_vlan_profile: "",
        olt_framed_pool: null,
      };
    }
    temp_form.olts[index][field] = value;
    setForm(temp_form);
  };

  return (
    <Modal show={show} onHide={() => handleClose()} size="xl">
      <form onSubmit={(event) => onSubmitData(event)}>
        <Modal.Header closeButton>
          <Modal.Title>Ubah Data Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LoadingInsideBoxWrapper>
            {project.loading && <LoadingInsideBox />}
            <AlertBox {...alert} setAlert={setAlert} />
            <div className="row">
              <div className="col-12 col-lg-6">
                <h4>Data Project</h4>
                <div className="form-group">
                  <label htmlFor="projectname">
                    Nama Project <RequiredAsterisk />
                  </label>
                  <input
                    type="text"
                    required
                    value={form.name}
                    onChange={(event) => setForm({ ...form, name: event.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="slugname">Slug</label>
                  <input
                    type="text"
                    value={form.slug}
                    onChange={(event) => setForm({ ...form, slug: event.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="projectname">
                    Nama PIC <i>(Person In Charge)</i> <RequiredAsterisk />
                  </label>
                  <input
                    type="text"
                    required
                    value={form.pic_name}
                    onChange={(event) => setForm({ ...form, pic_name: event.target.value })}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="partnername">Mitra/Partner</label>
                  <select
                    name="partnername"
                    id="partnername"
                    className="form-control"
                    value={form.partner_id}
                    onChange={(event) => setForm({ ...form, partner_id: event.target.value })}
                  >
                    <option value="">-- Pilih Partner --</option>
                    {partners.map((partner, index) => (
                      <option key={index} value={partner.id}>
                        {partner.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="projectname">
                    Alamat <RequiredAsterisk />
                  </label>
                  <input
                    type="text"
                    required
                    className="form-control"
                    value={address.address}
                    onChange={(event) => address.setAddress(event.target.value)}
                  />
                </div>
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label htmlFor="projectname">
                        RT <RequiredAsterisk />
                      </label>
                      <input
                        type="text"
                        required
                        className="form-control"
                        value={address.rt}
                        onChange={(event) => address.setRt(event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-auto">/</div>
                  <div className="col">
                    <div className="form-group">
                      <label htmlFor="projectname">
                        RW <RequiredAsterisk />
                      </label>
                      <input
                        type="text"
                        required
                        className="form-control"
                        value={address.rw}
                        onChange={(event) => address.setRw(event.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="projectname">
                    Provinsi <RequiredAsterisk />
                  </label>
                  <select
                    name="provinsi"
                    requiredid="provinsi"
                    className="form-control"
                    value={address.province}
                    onChange={(event) => address.changeProvince(event.target.value)}
                  >
                    <option value="">-- Pilih Provinsi --</option>
                    {address.provinces.map((province, index) => (
                      <option key={index} value={province.province}>
                        {province.province}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="projectname">
                    Kota/Kabupaten <RequiredAsterisk />
                  </label>
                  <select
                    name="kabupaten"
                    requiredid="kabupaten"
                    className="form-control"
                    value={address.city}
                    onChange={(event) => address.changeCity(event.target.value)}
                  >
                    <option value="">-- Pilih Kabupaten/Kota --</option>
                    {address.cities.map((city, index) => (
                      <option key={index} value={city.kota_kab}>
                        {city.kota_kab}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="projectname">
                    Kecamatan <RequiredAsterisk />
                  </label>
                  <select
                    name="kecamatan"
                    required
                    id="kecamatan"
                    className="form-control"
                    value={address.district}
                    onChange={(event) => address.changeDistrict(event.target.value)}
                  >
                    <option value="">-- Pilih Kecamatan --</option>
                    {address.districts.map((district, index) => (
                      <option key={index} value={district.kecamatan}>
                        {district.kecamatan}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="projectname">
                    Kelurahan <RequiredAsterisk />
                  </label>
                  <select
                    name="kelurahan"
                    required
                    id="kelurahan"
                    className="form-control"
                    value={address.addressId}
                    onChange={(event) => address.setAddressId(event.target.value)}
                  >
                    <option value="">-- Pilih Kelurahan --</option>
                    {address.addresslist.map((kelurahan, index) => (
                      <option key={index} value={kelurahan.id}>
                        {kelurahan.kelurahan}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="card mb-4">
                  <div className="card-body">
                    <h4>Setting PPN</h4>
                    <div className="row form-group">
                      <div className="col-auto">Exclude PPN di Invoice</div>
                      <div className="col-auto">
                        <Toggle
                          checked={form.invoice_value_added_tax === 1}
                          onChange={(event) => {
                            if (event.target.checked) {
                              setForm({ ...form, invoice_value_added_tax: 1 });
                            } else {
                              setForm({ ...form, invoice_value_added_tax: 0 });
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="ppnRate">Tarif PPN (%)</label>
                      <input
                        id="ppnRate"
                        type="number"
                        step="0.1"
                        min="0"
                        max="100"
                        value={form.invoice_value_added_tax_rate}
                        onChange={(event) =>
                          setForm({
                            ...form,
                            invoice_value_added_tax_rate: parseFloat(event.target.value) || 0,
                          })
                        }
                        className="form-control"
                        placeholder="Masukkan tarif PPN (contoh: 11.00)"
                        disabled={form.invoice_value_added_tax !== 1}
                        required={form.invoice_value_added_tax === 1}
                      />
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <h4>Setting Komisi</h4>
                    <div className="row form-group">
                      <div className="col-auto">Pencairan komisi dengan aplikasi Pulsa Pro</div>
                      <div className="col-auto">
                        <Toggle
                          checked={form.commission_disbursement === 1}
                          onChange={(event) => {
                            if (event.target.checked) {
                              setForm({ ...form, commission_disbursement: 1 });
                            } else {
                              setForm({ ...form, commission_disbursement: 0 });
                            }
                          }}
                        />
                      </div>
                    </div>
                    {form.commissions.map((commission, index) => (
                      <div key={index}>
                        <h5>Komisi {CommmissionTypeRole(commission.type)}</h5>
                        <div className="row">
                          <div className="col-12 col-lg-4">
                            <div className="form-group">
                              <label>Instalasi</label>
                              <input
                                type="number"
                                className="form-control"
                                value={commission.installation}
                                onChange={(event) =>
                                  onChangeCommission(index, "installation", event.target.value)
                                }
                                disabled={form.commission_disbursement !== 1}
                                required={form.commission_disbursement === 1}
                              />
                            </div>
                          </div>
                          {commission.relocate !== undefined && (
                            <div className="col-12 col-lg-4">
                              <div className="form-group">
                                <label>Relokasi</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={commission.relocate}
                                  onChange={(event) =>
                                    onChangeCommission(index, "relocate", event.target.value)
                                  }
                                  disabled={form.commission_disbursement !== 1}
                                  required={form.commission_disbursement === 1}
                                />
                              </div>
                            </div>
                          )}

                          {commission.dismantle !== undefined && (
                            <div className="col-12 col-lg-4">
                              <div className="form-group">
                                <label>Dismantle</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={commission.dismantle}
                                  onChange={(event) =>
                                    onChangeCommission(index, "dismantle", event.target.value)
                                  }
                                  disabled={form.commission_disbursement !== 1}
                                  required={form.commission_disbursement === 1}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="card mb-4">
                  <div className="card-body">
                    <h4>Setting Aktivasi</h4>
                    <div className="form-group">
                      <label label="framedPool">
                        Framed Pool <RequiredAsterisk />
                      </label>
                      <FramedPoolForm
                        value={form.framed_pool}
                        onChange={(value) => setForm({ ...form, framed_pool: value })}
                        new_value={form.new_framed_pool}
                        onChangeNew={(value) => setForm({ ...form, new_framed_pool: value })}
                      />
                    </div>
                    <div className="form-group">
                      <label label="OLTid">
                        OLT <RequiredAsterisk />
                      </label>
                      <OltForm
                        value={form.olt}
                        onChange={(value) => setForm({ ...form, olt: value })}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="vlanname">
                        VLAN <RequiredAsterisk />
                      </label>
                      <input
                        id="vlanname"
                        type="text"
                        value={form.vlan}
                        onChange={(event) => setForm({ ...form, vlan: event.target.value })}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="vlanprofile">
                        VLAN Profile <RequiredAsterisk />
                      </label>
                      <input
                        id="vlanprofile"
                        type="text"
                        value={form.vlan_profile}
                        onChange={(event) => setForm({ ...form, vlan_profile: event.target.value })}
                        className="form-control"
                      />
                    </div>
                    <div className="row form-group">
                      <div className="col-auto">Aktivasi Internet oleh Pengguna</div>
                      <div className="col-auto">
                        <Toggle
                          checked={form.user_activation === 1}
                          onChange={(event) => {
                            if (event.target.checked) {
                              setForm({ ...form, user_activation: 1 });
                            } else {
                              setForm({ ...form, user_activation: 0 });
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <h4>Multi OLT</h4>

                {form.olts?.map((olt, index) => (
                  <div className="card mb-4" key={index}>
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5>OLT #{index + 1}</h5>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => onRemoveOlt(index)}
                        >
                          <i className="fa fa-trash"></i> Hapus
                        </button>
                      </div>
                      <div className="form-group">
                        <label label="framedPool">Framed Pool</label>
                        <FramedPoolForm
                          value={olt.olt_framed_pool}
                          onChange={(value) => onChangeOltVal(index, "olt_framed_pool", value)}
                          new_value={olt.new_framed_pool || ""}
                          onChangeNew={(value) => onChangeOltVal(index, "new_framed_pool", value)}
                        />
                      </div>
                      <div className="form-group">
                        <label label="OLTid">OLT</label>
                        <OltForm
                          value={olt.olt}
                          onChange={(value) => onChangeOltVal(index, "olt", value)}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="vlanname">VLAN</label>
                        <input
                          id="vlanname"
                          type="text"
                          value={olt.olt_vlan}
                          onChange={(event) =>
                            onChangeOltVal(index, "olt_vlan", event.target.value)
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="vlanprofile">VLAN Profile</label>
                        <input
                          id="vlanprofile"
                          type="text"
                          value={olt.olt_vlan_profile}
                          onChange={(event) =>
                            onChangeOltVal(index, "olt_vlan_profile", event.target.value)
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                ))}

                <button type="button" onClick={() => onAddOlt()} className="btn btn-primary">
                  <i className="fa fa-plus"></i> Tambah OLT
                </button>
              </div>
            </div>
          </LoadingInsideBoxWrapper>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => handleClose()} type="button">
            Close
          </button>
          <button className="btn btn-primary" disabled={loading}>
            {loading ? "Menyimpan perubahan project ..." : "Simpan Data"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

function CommmissionTypeRole(val) {
  const ObjTypeRole = {
    technician: "Teknisi",
    "technician-freelance": "Teknisi Freelance",
    helper: "Helper",
    "helper-freelance": "Helper Freelance",
    sales: "Sales",
    "sales-freelance": "Sales Freelance",
  };

  return ObjTypeRole[val] || "-";
}
